import React from 'react';
import SectionText from '../../presentational/SectionText';
import data from '../../../core/data';
import Image from '../../presentational/Image';

import nudeBBCream from '../../../images/bb-cream/bb-cream-nude.jpg';

import nudeSwatch from '../../../images/bb-cream/nude-swatch.jpg';
import medSwatch from '../../../images/bb-cream/med-swatch.jpg';
import darkSwatch from '../../../images/bb-cream/dark-swatch.jpg';

function RangeContainer(props) {
  return (
    <section id="range">
      <div className="container">
        <h1 className="header">{ data.bbcream.bbRange.heading }</h1>
        <div className="container">
          <div className="row">
            <div className="col-sm-offset-1 col-sm-4">
              <div className="swatch">
                <h3>Nude</h3>
                <img src={ nudeSwatch } alt="Nude BB Cream Colour Swatch" />
              </div>
              <div className="swatch">
                <h3>Medium</h3>
                <img src={ medSwatch } alt="Medium BB Cream Colour Swatch" />
              </div>
              <div className="swatch">
                <h3>Dark</h3>
                <img src={ darkSwatch } alt="Dark BB Cream Colour Swatch" />
              </div>
            </div>
            <div className="col-sm-7">
              <img src={ nudeBBCream } alt="Nude BB Cream Product" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default RangeContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/BBPage/RangeContainer.jsx
 **/